/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ qty: NonNullable<unknown>, unit: NonNullable<unknown> }} Stock_Out_Dialog_Line_NeededInputs */

const vi_stock_out_dialog_line_needed = /** @type {(inputs: Stock_Out_Dialog_Line_NeededInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cần xuất: ${i?.qty} ${i?.unit}`)
};

/**

* @param {Stock_Out_Dialog_Line_NeededInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_dialog_line_needed = /** @type {((inputs: Stock_Out_Dialog_Line_NeededInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Dialog_Line_NeededInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_dialog_line_needed(inputs)
});